import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config';
import { toApiError } from '../lib/api-error';

type ApiErrorDailyStat = {
  date: string;
  errorCount: number;
  totalTestCount: number;
  errorRate: number | null;
};

type ApiErrorHistoryData = {
  dailyStats: ApiErrorDailyStat[];
};

type ApiResponse = {
  ok: boolean;
  data: ApiErrorHistoryData;
};

export function useApiErrorHistory() {
  return useQuery({
    queryKey: ['api-error-history'],
    queryFn: async (): Promise<ApiErrorHistoryData> => {
      const res = await fetch(`${API_URL}/dashboard/api-error-history`, {
        credentials: 'include',
      });
      if (!res.ok) {
        throw await toApiError(res, 'Failed to fetch API error history');
      }
      const body = (await res.json()) as ApiResponse;
      if (!body.ok) {
        throw new Error('API error history response was not ok');
      }
      return body.data;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
